import { useIntl } from "react-intl";
import { FormatXMLElementFn, Options, PrimitiveType } from "intl-messageformat";

import enMessages from "@/v1/i18n/translations/en.json";

export type MessageId = keyof typeof enMessages;

export type Translate = (
  id: MessageId,
  values?: Record<string, PrimitiveType | FormatXMLElementFn<string, string>>,
  opts?: Options,
) => string;

export const useTranslation = () => {
  const intl = useIntl();

  const t: Translate = (id, ...rest) => id && intl.formatMessage({ id }, ...rest);

  return {
    t,
  };
};
